/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiConstructionSite, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ConstructionSitesController.
 */
export class ConstructionSitesRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /construction_sites:prefill
     */
    public createPrefilled(): Promise<Result<ApiConstructionSite>> {
        return this.http.post<Result<ApiConstructionSite>, undefined>('/construction_sites:prefill', undefined);
    }

    /**
     * Calls GET /construction_sites:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiConstructionSite>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiConstructionSite>>>('/construction_sites:query', query);
    }

    /**
     * Calls POST /construction_sites:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiConstructionSite>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiConstructionSite>>, ListRequest>('/construction_sites:query', listRequest, query);
    }

    /**
     * Calls POST /construction_sites/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiConstructionSite>>> {
        return this.http.post<Result<LockedContextDto<ApiConstructionSite>>, undefined>(`/construction_sites/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /construction_sites/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiConstructionSite>> {
        return this.http.post<Result<ApiConstructionSite>, undefined>(`/construction_sites/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /construction_sites/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiConstructionSite[]>> {
        return this.http.post<Result<ApiConstructionSite[]>, string[]>('/construction_sites/locks', ids);
    }

    /**
     * Calls POST /construction_sites/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/construction_sites/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /construction_sites/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/construction_sites/${primaryId}/locks`);
    }

    /**
     * Calls GET /construction_sites/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiConstructionSite>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiConstructionSite>>(`/construction_sites/${primaryId}`, query);
    }

    /**
     * Calls POST /construction_sites
     */
    public add(dto: ApiConstructionSite): Promise<Result<ApiConstructionSite>> {
        return this.http.post<Result<ApiConstructionSite>, ApiConstructionSite>('/construction_sites', dto);
    }

    /**
     * Calls PUT /construction_sites/{primaryId}
     */
    public update(dto: ApiConstructionSite, primaryId: string): Promise<Result<ApiConstructionSite>> {
        return this.http.put<Result<ApiConstructionSite>, ApiConstructionSite>(`/construction_sites/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /construction_sites
     */
    public putRange(dtos: ApiConstructionSite[]): Promise<Result<ApiConstructionSite[]>> {
        return this.http.patch<Result<ApiConstructionSite[]>, ApiConstructionSite[]>('/construction_sites', dtos);
    }

    /**
     * Calls DELETE /construction_sites/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/construction_sites/${primaryId}`);
    }

    /**
     * Calls POST /constructionsites:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiConstructionSite>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiConstructionSite>>, ListRequestWithIds>('/constructionsites:batch', listRequest, query);
    }
}
